import { connect } from 'react-redux';

import ReturnPolicy from '../components/pages/return-policy';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({

});

const ReturnPolicyConnector = connect(mapStateToProps, mapDispatchToProps)(ReturnPolicy);

export default ReturnPolicyConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/return-policy-connector.js
 **/